import { localGet, localSet } from "../lib/Storage.ts";
import * as Html from "./Html.ts";
import * as amplify from "./amplify.ts";

Html.registerDom({
  panerighttoogle(){
    var 
      menu = document.querySelector('.pane-right'),
      page = menu.getAttribute('pane-right');

    if(menu.classList.contains('open')){
      menu.classList.remove('open')
    }else{
      menu.classList.add('open')
    }  
    menu.classList.add('animated-width');
    localSet('pane-right.'+page,""+menu.classList.contains('open'))
    
    
    setTimeout(()=>{amplify.publish('resized')},300);
  }
})

export function openPaneRight(){
  var 
    menu = document.querySelector('.pane-right'),
    page = menu.getAttribute('pane-right');

  menu.classList.add('open')
  menu.classList.add('animated-width');
  localSet('pane-right.'+page,""+menu.classList.contains('open'))
}
export function initPaneRight(){
  var 
    menu = document.querySelector('.pane-right'),
    page = menu.getAttribute('pane-right'),
    isSet = localGet('pane-right.'+page),
    isSetBoolean = isSet==='true';

  if(isSet===null){
    isSetBoolean = document.body.clientWidth>1280
  }  
  if(isSetBoolean){
    menu.classList.add('open')
  }else{
    menu.classList.remove('open')
  }  
}